import React from 'react';
import {
  EmptyState, KpiCard, Note, Select, Spinner,
} from '../../../components/app2';
import MapaCobertura from './MapaCobertura';

/**
 * La pestaña Cobertura: elegir empresa y año, y ver el mapa.
 *
 * Se separó de la pantalla para que el archivo de Sincronizaciones no acumule
 * tres vistas en un solo componente; aquí solo vive lo de la cobertura.
 */

const CoberturaPanel = ({
  empresas = [], esSuper, empresaId, onCambiarEmpresa,
  anio, onCambiarAnio, cobertura, cargando, onAbrirSolicitud,
}) => {
  const anioActual = new Date().getFullYear();
  // Desde 2021: antes de eso el SAT no conserva CFDI descargables por este medio.
  const anios = [];
  for (let a = anioActual; a >= 2021; a -= 1) anios.push(a);

  const dias = cobertura?.data || [];
  const resumen = cobertura?.resumen || null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: 16 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        {esSuper ? (
          <Select
            value={empresaId || ''}
            onChange={(e) => onCambiarEmpresa?.(e?.target?.value)}
            aria-label="Empresa del mapa de cobertura"
            style={{ width: 'auto', minWidth: 210 }}
          >
            <option value="">Elige una empresa</option>
            {empresas.map((c) => (
              <option key={c.id} value={c.id}>{c.name || c.businessName}</option>
            ))}
          </Select>
        ) : null}

        <Select
          value={anio}
          onChange={(e) => onCambiarAnio?.(Number(e?.target?.value))}
          aria-label="Año del mapa de cobertura"
          style={{ width: 'auto', minWidth: 120 }}
        >
          {anios.map((a) => <option key={a} value={a}>{a}</option>)}
        </Select>
      </div>

      {!empresaId ? (
        <EmptyState
          icon="apartment"
          title="Elige una empresa"
          text="El mapa muestra, día por día, qué se le ha pedido al SAT para esa empresa y qué trajo."
        />
      ) : cargando ? (
        <div style={{ display: 'grid', placeItems: 'center', padding: 40 }}>
          <Spinner size={26} />
        </div>
      ) : dias.length === 0 ? (
        <EmptyState
          icon="calendar_month"
          title="Sin datos para este año"
          text="No hay solicitudes ni recibos registrados en ese año."
        />
      ) : (
        <>
          <div className="a2-grid-kpi">
            <KpiCard icon="event_available" label="Días ya pedidos" value={`${resumen?.cubiertos ?? 0} / ${resumen?.dias ?? 0}`} />
            <KpiCard icon="receipt_long" label="Recibos en el año" value={(resumen?.recibos ?? 0).toLocaleString('es-MX')} />
            <KpiCard icon="event_busy" label="Días sin pedir" value={resumen?.sin_pedir ?? 0} />
            {(resumen?.fallidos ?? 0) > 0 ? (
              <KpiCard icon="error" label="Días que fallaron" value={resumen.fallidos} />
            ) : null}
          </div>

          {resumen?.sugerencia ? (
            <Note tone="info" icon="lightbulb">
              {/* El texto lo arma el servidor: es el mismo que sale al intentar
                  disparar el periodo, así dice exactamente lo mismo en los dos
                  sitios —incluido el aviso de que pedir los huecos juntos gasta
                  un solo cupo del SAT en vez de uno por tramo. */}
              <span>
                {resumen.mensaje}{' '}
                Se pide desde la pantalla de{' '}
                <strong style={{ color: 'var(--heading)' }}>Sincronización SAT</strong>.
              </span>
            </Note>
          ) : null}

          <MapaCobertura dias={dias} onAbrirSolicitud={onAbrirSolicitud} />
        </>
      )}
    </div>
  );
};

export default CoberturaPanel;
